import { ClipboardCheckIcon, FileCheck2Icon, FolderOpenIcon, NotebookTabsIcon } from 'lucide-react';

export const bonuses = [
  [
    '01',
    'Banco de 150 Proyectos Culturales Listos para Adaptar',
    '150 proyectos culturales completamente formulados y listos para adaptar a cualquier municipio o institución de Argentina. Organizados en 10 categorías: patrimonio, museos, bibliotecas, arte visual, música, teatro, literatura, festivales, cultura comunitaria y educación cultural. Cada proyecto incluye objetivos, actividades, presupuesto estimado, fuentes de financiamiento e indicadores.',
    '$18.000 ARS',
    FolderOpenIcon,
  ],
  [
    '02',
    '80 Formularios y Recursos Administrativos Editables',
    'Plantillas de proyectos listos para presentar al FNA, INT, INCAA e INAMU, formularios de inscripción a talleres, acreditación de eventos, solicitud de uso de espacios, encuestas de satisfacción, contratos de locación de servicios artísticos, convenios, presupuestos, actas, certificados, checklist de producción y plantillas de rendición de cuentas.',
    '$15.000 ARS',
    FileCheck2Icon,
  ],
  [
    '03',
    '300 Actividades Listas para el Aula',
    'Trescientas actividades pedagógicas diseñadas para la materia Gestión Cultural: talleres creativos, dinámicas de grupo, debates y foros, juegos culturales, proyectos interdisciplinarios, actividades digitales con IA y recursos imprimibles. Organizadas por nivel, tiempo disponible y modalidad, con consignas completas y criterios de evaluación.',
    '$15.000 ARS',
    NotebookTabsIcon,
  ],
  [
    '04',
    'Kit Completo de Evaluaciones (56 instrumentos)',
    '6 evaluaciones diagnósticas, 6 parciales por tomo, 4 finales integradoras, 8 rúbricas (proyecto, presentación oral, trabajo escrito, comunicación, eventos, diagnóstico, campaña y uso de IA), 6 listas de cotejo, 6 autoevaluaciones, 4 coevaluaciones, 6 bancos de preguntas y 4 tablas de calificación y seguimiento anual.',
    '$20.000 ARS',
    ClipboardCheckIcon,
  ],
] as const;
